export const TRANSACTION_CATEGORY_KINDS = [
  { id: 'income', label: 'Receita' },
  { id: 'expense', label: 'Despesa' },
];

export const TRANSACTION_CATEGORY_KIND_LABELS = Object.fromEntries(
  TRANSACTION_CATEGORY_KINDS.map((k) => [k.id, k.label])
);

export const UNCATEGORIZED_ID = '__uncategorized__';
export const UNCATEGORIZED_LABEL = 'Sem categoria';
